import {Component} from '@angular/core';
import {AlertController, NavParams, Keyboard} from 'ionic-angular';
import {AppConfigService} from "../../services/appConfig.service";
import {UserService} from "../../services/user.services";
import {AppDialog} from "../../component/appDialog";

@Component({
  templateUrl: 'agentUserQuota.html',
  selector: 'agent-user-quota-page',
})
export class AgentUserQuotaPage {
  private selectAction: string = "action1";
  private isOperation: boolean = false;
  private subpeList: any = [];
  //下级已有
  private xjpelist: any = [];

  constructor(private keyboard: Keyboard,public params: NavParams, private alertCtrl: AlertController, private userService: UserService) {
    this.getEditQuota();
  }

  getEditQuota() {
    let postData = {
      id: this.params.get("id")
    };
    this.userService.agentUserPointEdit(postData, this.alertCtrl).then(data=> {
      if (!data["msg"]) {
        this.subpeList = data["subpelist"];
        this.subpeList.map(item=> {
          item.levels = (item.levels * 100).toFixed(1);
          item.num2 = "";
          return item;
        });
        this.isOperation = data["subpelist"].length != 0;
        this.xjpelist = data["xjpelist"];
      } else {
        AppDialog.alert({
          alertCtrl: this.alertCtrl,
          message: data["msg"]
        });
      }
    });
  }

  saveFn() {
    let nums: any = [];
    this.subpeList.forEach(item=> {
      nums.push(item.num2 == "" ? 0 : item.num2);
    });
    let postData = {
      "num2[]": nums.join(",")
    };
    this.userService.agentUserSavePe(postData, this.alertCtrl).then(data=> {
      if (!data["msg"]) {
        AppDialog.alert({
          alertCtrl: this.alertCtrl,
          message: "修改成功"
        });
        this.getEditQuota();
      } else {
        AppDialog.alert({
          alertCtrl: this.alertCtrl,
          message: data["msg"]
        });
      }
    });
  }

  ionViewWillLeave(){
    this.keyboard.close();
  }
}



// WEBPACK FOOTER //
// ./src/pages/agentUserQuota/agentUserQuota.ts